let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dUZI3")).then(() => parcelRequire('4TzQ2'));